import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import BoardDialog from '../board/BoardDialog';
import OverlayController from '../overlay/OverlayController';
import paths from '../../services/paths';
import { Link } from 'react-router';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import mutations from '../../graphql/mutations';
import './BoardList.css';


export default compose(
    mutations.updateBoardsOrderMutationHoc
)(withRouter(class BoardList extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        updateBoardsOrder: PropTypes.func.isRequired
    };

    static defaultProps = {

    };

    constructor(props) {
        super(props);

        this.onSortClick = this.onSortClick.bind(this);
        this.onSaveSortClick = this.onSaveSortClick.bind(this);
        this.onCancelSortClick = this.onCancelSortClick.bind(this);
        this.onReorderMouseDown = this.onReorderMouseDown.bind(this);
        this.onReorderMouseMove = this.onReorderMouseMove.bind(this);
        this.onReorderMouseUp = this.onReorderMouseUp.bind(this);

        this.state = {
            sortMode: false,
            sortOrder: null,
            sortIndexMap: null,
            reorderItemBoardId: null,
            referenceY: null,
            translateY: null
        };
    }

    onSortClick(event) {
        event.preventDefault();

        let sortOrder = [];
        let sortIndexMap = {};

        this.props.project.boards.forEach((board, index) => {
            sortOrder.push(board);
            sortIndexMap[board.id] = index;
        });

        this.setState({
            sortMode: true,
            sortOrder: sortOrder,
            sortIndexMap: sortIndexMap,
            reorderItemBoardId: null,
            referenceY: null,
            translateY: null
        });
    }

    onSaveSortClick(event) {
        event.preventDefault();

        let projectId = this.props.project.id;
        let boardIds = this.state.sortOrder.map(board => board.id);

        OverlayController.showActivityIndicator();
        this.props.updateBoardsOrder(projectId, boardIds)
            .then(() => {
                OverlayController.hideActivityIndicator();
                this.resetSortState();

            })
            .catch(error => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
                this.resetSortState();
            });
    }

    onCancelSortClick(event) {
        event.preventDefault();
        this.resetSortState();
    }

    resetSortState() {
        this.setState({
            sortMode: false,
            sortOrder: null,
            sortIndexMap: null,
            reorderItemBoardId: null,
            referenceY: null,
            translateY: null
        });
    }

    onSettingsClick(board) {
        OverlayController.showOverlay({
            component: <BoardDialog projectId={this.props.project.id} board={board} />
        });
    }

    onCreateBoardClick() {
        OverlayController.showOverlay({
            component: <BoardDialog projectId={this.props.project.id} />
        });
    }

    onReorderMouseDown(event) {
        event.preventDefault();
        document.addEventListener('mousemove', this.onReorderMouseMove, false);
        document.addEventListener('mouseup', this.onReorderMouseUp, false);

        this.setState({
            reorderItemBoardId: event.currentTarget.dataset.itemBoardId,
            referenceY: event.clientY,
            translateY: 0
        });
    }

    onReorderMouseMove(event) {
        event.preventDefault();

        let sortOrder = this.state.sortOrder.slice();
        let sortIndexMap = this.state.sortIndexMap;
        let referenceY = this.state.referenceY;
        let translateY = event.clientY - referenceY;
        let itemIndex = this.state.sortIndexMap[this.state.reorderItemBoardId];
        let direction = translateY / Math.abs(translateY);
        let maxJumps = direction > 0 ? this.props.project.boards.length - 1 - itemIndex : itemIndex;
        let jumps = Math.min(maxJumps, Math.floor((Math.abs(translateY) + 19) / 40));

        if (jumps > 0) {
            translateY -= 40 * direction;
            referenceY += 40 * jumps * direction;
            let board = sortOrder[itemIndex];
            sortOrder.splice(itemIndex, 1);
            itemIndex += direction * jumps;
            sortOrder.splice(itemIndex, 0, board);
            sortIndexMap = sortOrder.reduce((map, board, index) => {map[board.id] = index; return map;}, {});
        }

        if ((itemIndex === 0 && translateY < 0) || (itemIndex === this.props.project.boards.length - 1 && translateY > 0)) {
            translateY = 0;
        }

        this.setState({
            sortOrder,
            sortIndexMap,
            referenceY,
            translateY
        });
    }

    onReorderMouseUp(event) {
        event.preventDefault();
        document.removeEventListener('mousemove', this.onReorderMouseMove, false);
        document.removeEventListener('mouseup', this.onReorderMouseUp, false);

        this.setState({
            reorderItemBoardId: null,
            referenceY: null,
            translateY: null
        });
    }

    pathForBoard(board) {
        return paths.board(this.props.project.id, board.id);
    }

    renderBoardReorderList() {
        let sortedBoard = this.props.project.boards.slice().sort((boardA, boardB) => this.state.sortIndexMap[boardA.id] - this.state.sortIndexMap[boardB.id]);
        return sortedBoard.map((board, index) => {
            let itemStyle = {};
            let className = 'materialListItem singleLine boardReorderListItem';
            if (this.state.reorderItemBoardId === board.id) {
                itemStyle = {transform: `translate(0px, ${this.state.translateY}px)`, zIndex: 10};
                className += ' dragging mdc-elevation--z10';
            }
            return (
                <div className={className} style={itemStyle} key={board.id} data-item-index={index} data-item-board-id={board.id} onMouseDown={this.onReorderMouseDown}>
                    <span className="materialListItemText">{board.name}</span>
                    <i className="materialListItemRightIcon fa fa-sort"/>
                </div>
            );
        });
    }

    renderBoardLinks() {
        return this.props.project.boards.map(board =>
            <FlatButton className="sidebarListItemButton" containerElement={<div/>} fullWidth={true} key={board.id}>
                <Link to={this.pathForBoard(board)} activeClassName="active" className="materialListItem singleLine">
                    <span className="materialListItemText">{board.name}</span>
                    {board.aclRole === "admin" &&
                    <div className="materialListItemRightIcon" onClick={(event) => event.preventDefault()} onMouseDown={(event) => event.stopPropagation()} >
                        <IconButton className="boardListSettingsButton" onClick={() => this.onSettingsClick(board)}>
                            <i className="fa fa-sliders"/>
                        </IconButton>
                    </div>
                    }
                </Link>
            </FlatButton>
        );
    }

    renderCreateBoardButton() {
        if (this.props.project.aclRole !== "admin") {
            return null;
        }
        return (
            <FlatButton className="sidebarListItemButton" containerElement={<div/>} fullWidth={true} onClick={() => this.onCreateBoardClick()}>
                <div className="materialListItem singleLine">
                    <span className="materialListItemText">Create Board</span>
                    <i className="materialListItemRightIcon material-icons">add</i>
                </div>
            </FlatButton>
        );
    }

    renderReorderButton() {
        if (this.props.project.aclRole !== "admin") {
            return null;
        }
        if (this.state.sortMode) {
            return ([
                <div key="cancelSort" className="materialListItemRightIcon">
                    <IconButton className="boardListSortButton" onClick={this.onCancelSortClick} onMouseDown={(event) => event.stopPropagation()}>
                        <i className="fa fa-times"/>
                    </IconButton>,
                </div>,
                <div key="saveSort" className="materialListItemRightIcon">
                    <IconButton className="boardListSortButton" onClick={this.onSaveSortClick} onMouseDown={(event) => event.stopPropagation()}>
                        <i className="fa fa-check"/>
                    </IconButton>
                </div>
            ]);
        } else {
            return (
                <div className="materialListItemRightIcon">
                    <IconButton className="boardListSortButton" onClick={this.onSortClick} onMouseDown={(event) => event.stopPropagation()}>
                        <i className="fa fa-sort"/>
                    </IconButton>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="materialList dense boardList">
                <div className="materialListItem materialListSubheader">
                    <div className="materialListItemText">Boards</div>
                    {this.renderReorderButton()}
                </div>
                {this.state.sortMode ? this.renderBoardReorderList() : this.renderBoardLinks()}
                {this.renderCreateBoardButton()}
            </div>
        );
    }
}));



// WEBPACK FOOTER //
// ./src/components/sidebar/BoardList.js